import { render, staticRenderFns } from "./List-Order-Reject.vue?vue&type=template&id=09b06e0b"
import script from "./List-Order-Reject.vue?vue&type=script&lang=js"
export * from "./List-Order-Reject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports